import { createLogger } from 'lib/logger'
import { createInMemoryStore } from 'lib/stores'

const logger = createLogger('turnstile', 'color: purple')

// Turnstile configuration - add your site key here
const TURNSTILE_CONFIG = {
  siteKey: '0x4AAAAAABmhWdyn2oJ7VHsJ', // process.env.TURNSTILE_SITE_KEY
  theme: 'auto', // auto, light, dark
  size: 'normal' // normal, compact
}

const state = createInMemoryStore({
  turnstileConfig: TURNSTILE_CONFIG
})

export function getTurnstileConfig(){
  return state.get().turnstileConfig
}

export function clearTurnstileConfig(){
  // Config is static now, so this is a no-op
  logger.info('clearTurnstileConfig called (no-op)')
}

// ACTIONS

export function loadTurnstileConfig(){
  logger.info('loadTurnstileConfig - using static config')
  // Config is already loaded statically
  return Promise.resolve()
}

export function reloadTurnstileConfig(){
  logger.info('reloadTurnstileConfig - using static config')
  // Config is static, no need to reload
  return Promise.resolve()
}

DEBUG.loadTurnstileConfig = loadTurnstileConfig
DEBUG.reloadTurnstileConfig = reloadTurnstileConfig

// HOOKS

export function useTurnstileConfig(){
  const { turnstileConfig } = state.useStore(['turnstileConfig'])

  return {
    turnstileConfig,
    loading: false, // Never loading since config is static
    error: null
  }
}

// Legacy exports for backward compatibility during migration
export const getCaptcha = getTurnstileConfig
export const clearCaptcha = clearTurnstileConfig
export const reloadCaptcha = reloadTurnstileConfig
export const useCaptcha = useTurnstileConfig
export const consumeCaptcha = () => {
  // Turnstile doesn't need to be "consumed" like the old captcha
  // Return empty object to maintain compatibility
  return {}
}
